import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Stack, Tab } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { selectAlert } from '../../store/alert/alertSlice';
import { useAppSelector } from '../../store/hook';
import MetricCalculation from './MetricCalculation';
import Output from './Output';

interface IIndexProps {}

const Index = (props: IIndexProps) => {
    const alert = useAppSelector(selectAlert);

    const { t } = useTranslation();

    const [value, setValue] = React.useState('1');

    const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Stack variant='scrollable' style={{ overflowX: 'auto' }}>
            <Stack height={'100%'} minWidth={900}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Stack direction={'row'} justifyContent={'space-between'} padding={'0 1rem'}>
                            <Stack direction={'row'} sx={{ width: { xs: '55%', sm: '70%', md: '80%', lg: 'auto' } }}>
                                <TabList variant='scrollable' onChange={handleChangeTab} aria-label='Engine tab'>
                                    <Tab variant={`${!alert.data?.title ? 'standard' : 'warning'}`} label={t('output')} value='1' />
                                    <Tab variant='standard' label={t('metricCalculation')} value='2' />
                                </TabList>
                            </Stack>
                        </Stack>
                    </Box>
                    <TabPanel value='1' style={{ height: '100%' }}>
                        <Stack height={'100%'} position={'relative'}>
                            <Output />
                        </Stack>
                    </TabPanel>
                    <TabPanel value='2' style={{ height: '100%' }}>
                        <Stack height={'100%'} position={'relative'}>
                            <MetricCalculation />
                        </Stack>
                    </TabPanel>
                </TabContext>
            </Stack>
        </Stack>
    );
};

export default Index;
